module.exports = __webpack_public_path__ + "static/media/logoCropped.15b6361a.png";